<div [ngClass]="sizeClass">
  <img src="assets/img/logo.png" alt="Logo Mdo Pay" />
</div>
